module.exports = __webpack_public_path__ + "static/img/fusai2.8fe4364.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fusai2.jpeg
// module id = LKgd
// module chunks = 1